import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 20px 3px 20px 3px;
  font-family: 'Source Code Pro', Courier, sans-serif;
  font-size: 0.8rem;
  white-space: pre;
  background: none;
  overflow: auto;
`

export const Text = styled.span`

`

export const Comment = styled.span`
  color: #aaa;
`

export const Key = styled.span`
  color: #b58900;

`

export const Block = styled.div`

`

export const NativeType = styled.span`
  font-weight: 600;
  color: #999;
`

export const OneOfOr = styled.div`
  color: #bbb;
  font-weight: 400;
  margin-top: 6px;
  white-space: pre;
`

export const OneOfBlock = styled(Block)`
  margin-top: 6px;
`